import { percent, formatPercent } from '../lib/format.js';
import { usageTone } from '../lib/status.js';

/**
 * Proportion bar for one ratio against a limit.
 *
 * Per the data-viz rules: the fill carries severity (nominal → warning →
 * critical) and the unfilled track is a lighter step of the *same* hue, so the
 * state reads across the whole bar rather than only the filled part. The bar is
 * decorative for assistive tech — the exact used/total figure sits beside it as
 * text, so nothing is gated behind colour.
 */
export function Meter({ used, total, format, readout, showPercent = true }) {
  const pct = percent(used, total);
  const tone = usageTone(pct);
  const text = readout || (format ? `${format(used)} / ${format(total)}` : `${used} / ${total}`);

  return (
    <div className="meter">
      <div className="meter__readout">
        <span className="meter__used mono">{text}</span>
        {showPercent ? <span className="meter__pct mono">{formatPercent(pct)}</span> : null}
      </div>
      {pct === null ? (
        <p className="meter__unknown">Not reported by the host.</p>
      ) : (
        <div className={`meter__track meter__track--${tone}`} aria-hidden="true">
          <div className={`meter__fill meter__fill--${tone}`} style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
